



















































































































































































































































import { fetchConfiguracion } from './fetchConfiguracion';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import moment from 'moment';
import Vue from 'vue';
import { AxiosVue } from '@/AxiosVue'; //
import { ServicioProxy } from '@/config/enums'; //
import config from '@/config/index'; //
import { ComponenteBaseStepper } from '@/views/base/ComponenteBaseStepper';
import { Component, Prop, Emit, Watch } from 'vue-property-decorator';
import { EstadoInterface } from '@/interfaces/Estado';
import { LoadingService } from '@/services/loadingService';
import { EstadoEntidad } from '@/config/enums';
import { EstadosService } from '@/services/estadosService';
import { Validator } from 'vee-validate';
import { PermisoAccionVm } from '@/views/base/PermisoAccionVm';
import { Funcionalidades } from '@/config/funcionalidades';
import { CodigoAccion } from '@/views/base/VariablesPermisos';
import { IFuncionalidad } from '@/interfaces/Funcionalidad';
import { AccionesInterface, IAccionesPadre } from '@/interfaces/Acciones';
const { AgGridVue } = require('ag-grid-vue');
import Confirmation from '@/components/Confirmation.vue'; //
import { SubAccion } from '@/views/base/VariablesPermisos';
import { EstadoGrillaVm } from '@/interfaces/EstadoGrillaVm';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import MantenedorGrid from '@/reusable/Grid/MantenedorGrid.vue';
import { makeAccionesColumnDef } from '@/reusable/Grid/aggridColumnDefUtils';
import { Accion } from '@/config/enums';
import { eventBus, actionsEvent } from '@/setup';
import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
} from 'ag-grid-community';

@Component({
  components: {
    DatePicker,
    'ag-grid-vue': AgGridVue,
    'app-confirmacion': Confirmation,
    MantenedorGridSinCodigo,
    MantenedorGrid,
  },
})
export default class EditarAlarma extends ComponenteBaseStepper {
  @Prop({ required: true }) tiposAlarma: Array<Object>;
  @Prop({ required: true }) ubicaciones: Array<Object>;
  @Prop({ required: true }) itemSelected: number;
  estadosDisponibles: Array<String> = ['ACTIVO', 'INACTIVO'];
  data: any = {};
  ordesList: any = [];
  funcionalidad: Funcionalidades =
    Funcionalidades.TablaEmailsConfiguracionAlarmas;

  rules = {
    required: (value: any) => !!value || 'Required.',
    email: (value: any) => {
      if (value !== '') {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Invalid e-mail.';
      } else {
        return 'Invalid e-mail.';
      }
    },
  };

  async returnUnicos(data: any) {
    let hash: any = {};
    let unicos = data.filter((dato: any) =>
      hash[dato.alarmaemail.toUpperCase()]
        ? false
        : (hash[dato.alarmaemail.toUpperCase()] = true)
    );
    return unicos;
  }

  async addEmail() {
    let validEmail = this.rules.email(this.formFields.correo.value);
    if (validEmail !== 'Invalid e-mail.') {
      let dato = {
        alarmaemail: this.formFields.correo.value.toUpperCase(),
      };

      this.ordesList.push(dato);
      let totales = this.ordesList || [];
      this.ordesList = await this.returnUnicos(totales);
      this.gridApi.setRowData(this.ordesList);
      this.gridApi.setDomLayout('autoHeight');
      this.formFields.correo.value = '';
    } else {
      this.$snotify.error('Por favor ingrese un email valido', {
        timeout: 3000,
      });
    }
  }

  async getInformacion() {
    let self = this;
    this.loadingService.showLoading();
    return fetchConfiguracion(
      { alarmaId: this.itemSelected },
      'conecta_configuracion_alarmas/inicio'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          return data.data.data.LISTA[0];
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error al cargar las alarmas', {
          timeout: 3000,
        });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  anulada: boolean = false;
  totalEmailsInicial: any;
  async cargarDatos() {
    this.data = await this.getInformacion();
    if (this.data.estado == 'INACTIVO') {
      this.anulada = true;
    }
    this.formFields.nombre.value = this.data.alarmanombre;
    this.formFields.tipoAlarma.value = this.data.alarmatipoid;
    this.formFields.tipoValor.value = this.data.configvalor;
    this.formFields.ubicacion.value = this.data.tipoubicaid;
    this.formFields.condicion.value = this.data.alarmacomparaid;
    this.formFields.valor.value = this.data.alarmavalor;
    this.formFields.tipoOperacion.value = this.data.moviopera_tipo;
    this.formFields.motivo.value = this.data.motiid;
    this.formFields.generaOpera.value = this.data.alarmagenera_opera == 't';
    this.formFields.estado.value = this.data.estado;
    this.formFields.tipoEqui.value = this.data.tipoeqid;
    this.formFields.estado.value = this.data.estado;
  }

  cargarTipoValor() {
    let alarma: any = this.tiposAlarma.find(
      (e: any) => e.configid == this.formFields.tipoAlarma.value
    );
    this.formFields.tipoValor.value =
      alarma && alarma.configvalor ? alarma.configvalor : '';
  }

  condiciones: Array<object> = [];
  motivosBaja: Array<object> = [];
  tiposOperacion: Array<object> = [];
  tiposEquipo: Array<object> = [];
  bajaid: string;
  async getOpcionesEditar() {
    let self = this;
    this.loadingService.showLoading();
    return fetchConfiguracion({}, 'conecta_configuracion_alarmas/get_opciones')
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.condiciones = data.data.CONDICIONES;
          this.tiposOperacion = data.data.TIPOSOPERACION;
          this.bajaid = data.data.BAJAID;
          this.motivosBaja = data.data.MOTIVOSBAJA;
          this.tiposEquipo = data.data.TIPOS_EQUI;
          return;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error al cargar las alarmas', {
          timeout: 3000,
        });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  mounted() {
    this.cargarDatos();
    this.getOpcionesEditar();
  }

  formFields: {
    nombre: any;
    tipoAlarma: any;
    ubicacion: any;
    condicion: any;
    tipoValor: any;
    valor: any;
    correo: any;
    tipoOperacion: any;
    motivo: any;
    generaOpera: any;
    estado: any;
    tipoEqui: any;
  } = {
    nombre: {
      label: 'Nombre (Obligatorio)',
      value: '',
    },
    tipoAlarma: {
      label: 'Tipo Alarma (Obligatorio)',
      value: '',
    },
    ubicacion: {
      label: 'Ubicación (Obligatorio)',
      value: '',
    },
    condicion: {
      label: 'Condición (Obligatorio)',
      value: '',
    },
    tipoValor: {
      label: 'Tipo Valor',
      value: '',
    },
    valor: {
      label: 'Valor (Obligatorio)',
      value: '',
    },
    correo: {
      label: 'Correo',
      value: '',
    },
    tipoOperacion: {
      label: 'Tipo Operación (Obligatorio)',
      value: '',
    },
    motivo: {
      label: 'Motivo (Obligatorio)',
      value: '',
    },
    generaOpera: {
      label: 'Genera Operación',
      value: false,
    },
    estado: {
      label: 'Estado',
      value: '',
    },
    tipoEqui: {
      label: 'Tipo Equipo',
      value: '',
    },
  };

  // permisos
  permisosActuales: PermisoAccionVm[] = [];

  // Declarar todas las posibles subAcciones
  EditarAlarma: PermisoAccionVm = {
    accion: 'Editar - Editar Alarma',
    visible: true,
    step: 1,
    codigoAccionPadre: CodigoAccion.Editar,
  };

  permisosTotales: PermisoAccionVm[] = [this.EditarAlarma];

  // Globales
  $snotify: any;
  e1: number = 1;
  dialog: boolean = true;
  validForm: boolean = false;
  loadingService = new LoadingService();
  btnBloquear: boolean = false;
  dialogConfirmacion: boolean = false;
  dialogConfirmacionClose: boolean = false;

  //data
  estadosServices: EstadosService = new EstadosService();
  estados: EstadoInterface[] = this.estadosServices.getEstadosVisibles();

  //Interface
  editedItem: IFuncionalidad = {};

  //controllers
  readonly controller: string = 'funcionalidad';
  readonly controllerAccion: string = 'accion';
  readonly controllerModuloAccion: string = 'ModuloAccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);

  gridOptions: GridOptions;
  // Grilla
  gridApi: GridApi;
  columnApi: ColumnApi;
  columnDefs: Array<ColDef> = [];
  estadoGrillaVm: EstadoGrillaVm;
  serverSide: any;

  funcionalidades: Array<IFuncionalidad> = [];
  alerta = false;
  async getEmails() {
    let self = this;
    this.loadingService.showLoading();
    return fetchConfiguracion(
      { alarmaId: this.itemSelected },
      'conecta_configuracion_alarmas/get_emails'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          return data.data.data.LISTA;
        } else {
          if (!this.alerta)
            self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          this.alerta = true;
          this.totalEmailsInicial = [{ alarmaemail: '' }];
          return [];
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error al cargar las alarmas', {
          timeout: 3000,
        });
        return [];
      })
      .finally(() => {
        this.loadingService.hideLoading();
      });
  }

  async handleGridReady(event: GridReadyEvent) {
    this.ordesList = await this.getEmails();
    if (this.ordesList.length > 0) {
      this.totalEmailsInicial = this.ordesList.map((e: any) => {
        return { alarmaemail: e.alarmaemail };
      });
    }

    this.gridApi = event.api;
    this.gridApi.setRowData(this.ordesList);
    this.gridApi.setDomLayout('autoHeight');
  }

  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }
  }

  onSelectionChanged(params: any) {}

  dateFormatter(params: any) {
    return moment(params.value).format('YYYY/MM/DD');
  }

  constructor() {
    super();
    this.columnDefs = [
      {
        headerName: 'Email',
        field: 'alarmaemail',
        resizable: true,
        sortable: true,
        hide: false,
        minWidth: 500,
        width: 500,
        lockPinned: true,
        cellStyle: { textAlign: 'left' },
      },
    ];

    this.gridOptions = {
      pagination: true,
      paginationPageSize: 6, //Solución Paginación
      //cacheBlockSize: 50, //Solución Paginación
      //paginationAutoPageSize: false,
      rowModelType: 'normal',
      columnDefs: this.columnDefs,
      //rowModelType: 'serverSide',
      serverSideDatasource: this.serverSide,
      rowSelection: 'single',
      columnTypes: {
        fecha: {
          //cellRenderer: this.fechaFilter,
          sortable: true,
          resizable: true,
          filter: false,
        },
      },
      suppressCsvExport: true,
      suppressExcelExport: true,
      onGridReady: this.handleGridReady,
      onModelUpdated: this.onModelUpdated,
      onSelectionChanged: this.onSelectionChanged,

      processCellForClipboard: ({ value }) => {
        return value instanceof moment
          ? this.formatFecha(value as moment.Moment)
          : value;
      },
      onGridSizeChanged: event => {
        //event.api.sizeColumnsToFit();
      },
    };
  }

  formatFecha(fecha: moment.Moment) {
    return fecha.format('DD-MM-YYYY');
  }

  async postCambios() {
    let self = this;
    this.loadingService.showLoading();
    return fetchConfiguracion(
      {
        alarmaId: this.itemSelected,
        inicial: this.data,
        cambios: this.datoEditado,
        bajaid: this.bajaid,
        usuarioId: JSON.parse(localStorage.getItem('user')).id,
        clienteId: JSON.parse(localStorage.getItem('user')).clienteDefecto,
      },
      'conecta_configuracion_alarmas/editar_alarma'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          self.$snotify.success(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          this.closeModal(false);
          return;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error al cargar los cambios', {
          timeout: 3000,
        });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  datoEditado: any;
  async EditarDatoAlarma() {
    this.data.emails = this.totalEmailsInicial;
    if (
      this.formFields.tipoOperacion.value == this.bajaid &&
      this.formFields.motivo.value == ''
    ) {
      this.$snotify.error('Por favor agregue el motivo para la baja de SIM', {
        timeout: 3000,
      });
      return;
    } else if (
      this.formFields.tipoOperacion.value != this.bajaid &&
      this.data.moviopera_tipo == this.bajaid
    ) {
      this.formFields.motivo.value = '';
    }
    this.datoEditado = {
      alarmatipoid: this.formFields.tipoAlarma.value,
      tipoubicaid: this.formFields.ubicacion.value,
      alarmacomparaid: this.formFields.condicion.value,
      alarmavalor: this.formFields.valor.value,
      moviopera_tipo: this.formFields.generaOpera.value
        ? this.formFields.tipoOperacion.value
        : '',
      motiid: this.formFields.generaOpera.value
        ? this.formFields.motivo.value
        : '',
      tipoeqid: this.formFields.tipoEqui.value,
      estado: this.formFields.estado.value,
      alarmagenera_opera: this.formFields.generaOpera.value ? 't' : 'f',
      emails:
        this.ordesList.length > 0
          ? this.ordesList.map((e: any) => {
              return { alarmaemail: e.alarmaemail };
            })
          : [],
    };

    if (
      this.formFields.generaOpera.value &&
      this.formFields.tipoOperacion.value == ''
    ) {
      this.$snotify.error('Por favor ingrese el tipo de operación', {
        timeout: 3000,
      });
      return;
    }

    await this.postCambios();
  }

  initialize() {
    actionsEvent.$on('actionsEvent', (data: any) => {
      if (
        this.funcionalidad === Funcionalidades.TablaEmailsConfiguracionAlarmas
      ) {
        if (data.action === Accion.Eliminar) {
          let item: any = null;
          this.gridApi.forEachNode((rowNode: RowNode) => {
            if (data.id == rowNode.data.id) {
              item = rowNode.data;
              return true;
            }
          });
          if (item !== null) {
            let indexDelete = this.ordesList.indexOf(
              data.cellRendererParams.data
            );
            this.ordesList.splice(indexDelete, 1);
            this.gridApi.setRowData(this.ordesList);
            this.gridApi.setDomLayout('autoHeight');
          }
        }
      }
    });
  }
  created() {
    this.initialize();
  }

  closeModal(val: boolean) {
    document.getElementById('cardDivModulos').scrollIntoView(true);
    this.editedItem = {};
    this.e1 = 1;
    this.$emit('modalAsociacionEmit', false);
    this.$validator.reset(); //Reset Validaciones
    this.dialog = false;
  }

  confirmCallbackConfirm(val: boolean) {
    this.dialogConfirmacionClose = false;
    if (val) {
      this.closeModal(false);
    }
  }

  cierraMenu() {
    var appBanners = document.getElementsByClassName(
      'ag-menu'
    ) as HTMLCollectionOf<HTMLElement>;
    if (appBanners.length > 0) {
      appBanners[0].remove();
    }
  }
}
